import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IType from '../interfaces/IType';
import { iconDeviceMarkersOptions } from '~/features/Map/components/MarkerGenerator/components/DeviceMarker/icon';



export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue, getValues} = useForm<IType>();
  const fields = [
      { name: 'id', type: 'hidden'},
      { name: 'acronym', type: 'string'},
      { name: 'mask', type: 'string'}, 
  ];
  
    return(
      <CrudEdit 
        model={'dispatch/code'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Dispatch Code successfully updated!'}  
        title={'Edit Dispatch Code'}
        getValues={getValues} 
      />
    )
}
